import React from "react";
import { More } from "../../assets/svgs/icons";
import { Round as BadgeRound } from "../badge";
import { formatDateString } from "../../utils/commonFunctions";

export interface UserProps {
  state?: "inactive" | "active" | "expired";
  email?: string;
  avatarUrl?: string;
  endDate?: string; // For active state - format: "YYYY-MM-DD"
  showButton?: boolean;
  onMoreClick?: () => void;
  onPurchaseClick?: () => void;
}

const WebUser: React.FC<UserProps> = ({
  state = "inactive",
  email = "donga@donga.com",
  avatarUrl,
  endDate,
  showButton = true,
  onMoreClick,
}) => {
  const onPurchaseClick = () => {
    window.open(
      `${process.env.REACT_APP_DONGA_STORE}/subscription?anchor=2`,
      "_blank",
    );
  };

  return (
    <div className="bg-white box-border flex gap-4 items-center justify-center pl-4 pr-0 py-4 w-full">
      {/* Container */}
      <div className="flex-1 bg-white flex gap-[10px] h-12 items-center rounded-[24px]">
        {/* Avatar */}
        <div className="border border-[#e2d5fc] rounded-[24px] shrink-0 w-12 h-12 overflow-hidden">
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt="User avatar"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-[#cd3ec7] via-[#5328df] to-[#2d8efa] flex items-center justify-center text-white font-bold text-lg">
              U
            </div>
          )}
        </div>

        {/* User Info */}
        <div className="flex-1 flex flex-col gap-1 items-start justify-center">
          {/* Validity Section */}
          <div className="flex gap-1 items-center">
            {/* inactive 상태 */}
            {state === "inactive" && (
              <button onClick={onPurchaseClick} className="cursor-pointer">
                <p
                  className="bg-clip-text bg-gradient-to-r font-bold from-[#cd3ec7] leading-5 text-[14px] text-center to-[#2d8efa] tracking-[-0.28px] via-50% via-[#5328df] whitespace-nowrap underline"
                  style={{
                    WebkitTextFillColor: "transparent",
                    textDecorationColor: "#5328df",
                  }}
                >
                  이용권 구매가 필요해요!
                </p>
              </button>
            )}

            {/* active 상태 */}
            {state === "active" && (
              <>
                <BadgeRound size="sm" style="line" color="main">
                  이용중
                </BadgeRound>
                <p className="font-medium leading-5 text-[#212121] text-[14px] text-center tracking-[-0.28px] whitespace-nowrap">
                  {endDate ? `${formatDateString(endDate)}까지` : ""}
                </p>
              </>
            )}

            {/* expired 상태 */}
            {state === "expired" && (
              <>
                <BadgeRound size="sm" style="line" color="gray">
                  기간만료
                </BadgeRound>
                <button
                  onClick={onPurchaseClick}
                  className="flex items-center justify-center rounded-[4px] transition-colors hover:bg-[#f7f7f7]"
                >
                  <span className="font-bold text-[#212121] text-[14px] text-center tracking-[-0.28px] leading-5 underline whitespace-nowrap">
                    이용권 연장하기
                  </span>
                </button>
              </>
            )}
          </div>

          {/* Email */}
          <p className="font-regular text-[#888888] text-[12px] text-center tracking-[-0.24px] leading-4 whitespace-nowrap">
            {email}
          </p>
        </div>
      </div>

      {/* More Button */}
      {showButton && (
        <button
          onClick={onMoreClick}
          className="box-border flex gap-[10px] items-center justify-center p-3 shrink-0 size-12 hover:bg-[#f7f7f7] rounded-full transition-colors"
          aria-label="More options"
        >
          <More width={24} height={24} className="text-[#212121] rotate-90" />
        </button>
      )}
    </div>
  );
};

export default WebUser;
